module.exports = __webpack_public_path__ + "static/img/解决2.ef0fa26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ds-img/解决2.png
// module id = D5i6
// module chunks = 2